<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        工时制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 坐班指纹打卡 -->
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars" v-if="fingerprintShow">
                    <h4 class="labourParticulars-title labourParticulars-title-active">坐班指纹打卡</h4>
                    <p>1. 考勤周期</p>
                    <span class="spanClass">考勤周期为上月26日至本月25日。</span>
                    <p>2. 迟到、早退</p>
                    <span>（1）迟到或早退15分钟（不含）内，合计2次不予扣费；第3次及以上，按照 50 元/次进行扣款。</span>
                    <span>（2）迟到或早退15 分钟（含）-30 分钟（不含）内，按照 50 元/次进行扣款。</span>
                    <span>（3）迟到或早退30 分钟（含）-3 小时（不含）内，视为旷工0.5天。</span>
                    <span>（4）迟到或早退3 小时（含）以上，视为旷工1天。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars" v-if="fingerprintShow">
                    <h4 class="labourParticulars-title labourParticulars-title-active">坐班指纹打卡</h4>
                    <p>3. 忘打卡</p>
                    <span class="spanClass">（1）2次以内（含）忘记打卡，不予扣费；第3次及以上，按照50元/次进行扣款。</span>
                    <span class="spanClass">（2）若一天中，早晚均忘记打卡，不接受两次忘记打卡申请，可记为假期（调休、年假、事假等）。</span>
                    <span class="spanClass">（3）如指纹出现问题，需人脸和打卡机合照，并保证能看清打卡机上显示的时间，如觉得照片不方便，可录小视频，并第一时间与人力资源部联系报备，查找问题原因。</span>
                    <p>4. 注</p>
                    <span class="spanClass">2次以上迟到且2次以上忘记打卡需部门总监批准后方可生效，否则一律按无故旷工处理，情节严重可按相关法律解除劳动合同。</span>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  data() {
    return {
      fingerprintShow: false,
      flowShow: false,
      agreementShow: false
    };
  },
  methods: {
    getOnPage1(){
      var name = this.$route.params.name;
      if(name == 'qw'){
        this.$router.push({name:"IssueManpower"})
      }else{
        this.$router.push({name:"Manpower"})
      }
    },
    getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
    fn() {
      var code = this.$route.params.code;
      if (code == 11) {
        this.fingerprintShow = true;
      } else if (code == 12) {
        this.flowShow = true;
      } else if (code == 79) {
        this.agreementShow = true;
      }
    }
  },
  mounted() {
    this.fn();
    var mySwiper = new Swiper(".swiper-container", {
      direction: "vertical", // 垂直切换选项
      // loop: true // 循环模式选项
    });
  }
};
</script>

<style>
.swiper-container {
  width: 100%;
  height: 100%;
}

.box-labourParticulars {
  width: 100%;
  height: 100%;
  background: rgba(244, 244, 244, 1);
  overflow: hidden;
}

.nav {
  width: 100%;
  height: 50px;
  background: #11a093;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  position: relative;
  margin-bottom: 17px;
}

.upClass,
.searchClass {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.upClass {
  width: 12px;
  float: left;
  left: 10px;
}

.searchClass {
  width: 19px;
  float: right;
  right: 10px;
}

.labourParticulars {
  width: 90%;
  height: 83%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
  border-radius: 11px;
  padding-top: 5%;
  position: relative;
}

.labourParticulars .labourParticulars-title {
  text-align: center;
  font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
  margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
  display: block;
  line-height: 30px;
  margin-left: 16px;
  margin-right: 16px;
  color: #888787;
  font-size: 14px;
}

.labourParticulars .spanClass {
  text-indent: 30px;
}

.labourParticulars_bottomImg {
  width: 15%;
  display: block;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
  bottom: 12px;
}

.QRcode {
  display: block;
  margin: 10px auto;
}
.labourParticulars-title-active {
  font-size: 16px
}

</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpowerParticulars.vue